import { lazy } from 'react';

const ContactsList = lazy(() => import('./ContactsList'));

const ContactsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'contacts',
      element: <ContactsList />,
    },
  ],
};

export default ContactsConfig;
